import { StyleSheet, Font } from "@react-pdf/renderer";

// 웹에서 폰트 등록
Font.register({
  family: "NotoSansKR",
  fonts: [
    {
      src: "https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff2",
      fontWeight: "normal",
    },
    {
      src: "https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff2",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 0,
    margin: 0,
    fontFamily: "NotoSansKR",
    position: "relative",
  },
  pageView: {
    margin: "20px 10px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerTitle: {
    fontWeight: "bold",
    fontSize: "20px",
    marginBottom: "15px",
  },
  headerDate: {
    fontSize: "13px",
    alignSelf: 'flex-end',
  },
  headerUserName: {
    fontSize: "13px",
    alignSelf: "flex-start",
  },
  table: {
    display: "table",
    width: "auto",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: "11px",
    paddingTop: 2,
    paddingBottom: 2,
    backgroundColor: "#F3E2A9",
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
  },
  tableColRow: {
    fontWeight: 'normal',
    fontSize: "11px",
    paddingTop: 1,
    paddingBottom: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
  },
  tableCenter: {
    textAlign: "center",
  },
  tableRight: {
    textAlign: "right",
    paddingRight: 5,
  },
  tableContainer: {
    borderTop: "1px solid black",
    borderLeft: "1px solid black",
  },
  tableRoomContainer: {
    marginTop: "20px",
    marginBottom: "10px",
  },
  tableTotalPrice: {
    backgroundColor: "#A4A4A4",
    paddingTop: 3,
    paddingBottom: 3,
    fontWeight: "bold",
    fontSize: "12px"
  },
  footerContainer: {
    width: "100%",
    position: 'absolute',
    bottom: 0,
  },
  footer: {
    display: "flex",
    alignItems: "flex-end",
    marginLeft: "10px",
    marginRight: "10px",
    paddingBottom: "10px",
    paddingTop: "10px",
    borderTop: "2px solid black"
  },
  subLogo: {
    width: 180,
  },
});

export default styles;

